function convertBelongToName(belongs, belong, t) {
  let resultName = t ? t('Admin_Convert_invalidInput', '잘못된 입력') : '잘못된 입력';
  belongs.forEach((el) => {
    if (belong === el.id) {
      resultName = el.name;
      return resultName;
    }
  });

  return resultName;
}

function convertNameToBelong(belongs, belongName) {
  let resultNum = 0;
  belongs.forEach((el, idx) => {
    if (belongName === el.name) {
      resultNum = el.id;
      return resultNum;
    }
  });

  return resultNum;
}

// role 번호에 따라 역할을 한글로 변환하여 리턴
function convertRole(role, t) {
  if (role === 0) return t ? t('Admin_Convert_admin', '관리자') : '관리자';
  else if (role === 1) return t ? t('Admin_Convert_doctor', '의사') : '의사';
  else if (role === 2) return t ? t('Admin_Convert_stomaNurse', '장루 간호사') : '장루 간호사';
  else return "";
}
export { convertBelongToName, convertNameToBelong, convertRole };
